import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { useRef, useEffect } from 'react';
import ddt from '@wix/da-ddt';
const logger = process.env.NODE_ENV === 'test' ? console : ddt.createLogger('react');
// this is a helper to help debug re-renders
function objectDiff(from, to) {
    const diff = {};
    Object.keys(_object_spread({}, from, to)).forEach((key)=>{
        if (from[key] !== to[key]) {
            diff[key] = {
                from: from[key],
                to: to[key]
            };
        }
    });
    return diff;
}
export function useDebugRerenders(name, props) {
    const previousProps = useRef(undefined);
    useEffect(()=>{
        if (previousProps.current) {
            const diff = objectDiff(previousProps.current, props);
            if (Object.keys(diff).length) {
                logger.log(`${name} re-render reason:`, diff);
            } else {
                logger.log(`${name} re-rendered without prop changes`);
            }
        }
        previousProps.current = props;
    });
}

//# sourceMappingURL=useDebugRerenders.js.map